import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChatAnalysisStats } from '../../types/messaging';
import './ChatStatsBar.css';

interface ChatStatsBarProps {
    stats: ChatAnalysisStats | null;
}

const ChatStatsBar: React.FC<ChatStatsBarProps> = ({ stats }) => {
    const { t } = useTranslation('messaging');

    if (!stats) return null;

    return (
        <div className="chat-stats-bar">
            <div className="chat-stats-item">
                <span className="chat-stats-value">+{stats.wordsAnalyzed}</span>
                <span className="chat-stats-label">{t('chatAnalysis.words')}</span>
            </div>
            <div className="chat-stats-divider" />
            <div className="chat-stats-item">
                <span className="chat-stats-value">{Math.round(stats.grammarAccuracy * 100)}%</span>
                <span className="chat-stats-label">{t('chatAnalysis.grammar')}</span>
            </div>
            <div className="chat-stats-divider" />
            <div className="chat-stats-item">
                <span className="chat-stats-value">{stats.streak}</span>
                <svg className="chat-stats-flame" width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 23c-4.97 0-9-3.58-9-8 0-3.07 2.13-5.81 3.5-7.2.37-.37.95-.11.95.42 0 1.66.87 3.22 2.13 4.08.3.2.7.03.78-.33.3-1.35.96-2.87 2.14-4.47C14.5 4.77 15 2 14 0c0 0 4 2 6 7 .67 1.67 1 3.33 1 5 0 4.42-4.03 8-9 8 0 0 0-3 0 0zm-2.5-5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5c0-1.23-1-2.76-2.5-4-1.5 1.24-2.5 2.77-2.5 4z"/>
                </svg>
                <span className="chat-stats-label">{t('chatAnalysis.streak')}</span>
            </div>
            {stats.newWordsUsed.length > 0 && (
                <>
                    <div className="chat-stats-divider" />
                    <div className="chat-stats-item chat-stats-new-words">
                        <svg className="chat-stats-star" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                        </svg>
                        <span className="chat-stats-value">{stats.newWordsUsed.join(', ')}</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default ChatStatsBar;
